import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Website } from '../../../../../../../mymail/models/website.model';

@Component({
  selector: 'mprd-websites-list',
  templateUrl: './websites-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebsitesListComponent {
  @Input() websites: Website[];
  @Output() selectWebsite: EventEmitter<string> = new EventEmitter();

  constructor() {}

  changeSelectedWebsite(accessNumber: string) {
    this.selectWebsite.emit(accessNumber);
  }
}
